import { TrashIcon, UsersIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { FormDateFieldDS, FormRadioGroupDS } from 'components/reusable/form/FormFields'
import { IconButton } from 'slab'
import { numberToOrdinalText } from 'utils/numberUtils'

import { type Employees } from './EmployeeEntry'

type Props = {
  employeeIndex: number
  dependentIndex: number
  onRemove: () => void
}

export function DependentInfoEntry ({ employeeIndex, dependentIndex, onRemove }: Props) {
  const { control, register, formState: { errors, isSubmitting } } = useFormContext<Employees>()

  return (
    <div className='flex flex-col gap-6 rounded-lg bg-gray-50 p-4'>
      <div className='flex flex-row justify-between'>
        <div className='flex flex-row gap-1 items-center'>
          <UsersIcon className='w-3 h-3 text-gray-800' />
          <span className='text-sm text-gray-800'>{numberToOrdinalText(dependentIndex + 1)} dependent</span>
        </div>
        <IconButton
          icon={TrashIcon}
          label='Remove dependent'
          onClick={onRemove}
          disabled={isSubmitting}
        />
      </div>
      <div className='flex flex-col xs:flex-row gap-4'>
        <div>
          <FormRadioGroupDS<Employees>
            control={control}
            name={`employees.${employeeIndex}.dependents.${dependentIndex}.relationship`}
            label='Relationship'
            layout='horizontal'
            buttonVariant='bordered'
            buttonSize='small'
            options={[
              { label: 'Spouse', value: 'spouse' },
              { label: 'Child', value: 'child' },
            ]}
            rules={{ required: 'Relationship is required.' }}
            disabled={isSubmitting}
          />
        </div>
        <div>
          <FormDateFieldDS<Employees>
            fieldId={`employees.${employeeIndex}.dependents.${dependentIndex}.date_of_birth`}
            fieldLabel='Date of birth'
            register={register}
            placeholder='Date of birth'
            validationRule={{
              required: 'Date of birth is required.',
              validate: (value: string) => {
                if (new Date(value) > new Date()) {
                  return 'Date of birth cannot be in the future.'
                }
              },
            }}
            error={errors.employees?.[employeeIndex]?.dependents?.[dependentIndex]?.date_of_birth}
            disabled={isSubmitting}
          />
        </div>
      </div>
    </div>
  )
}
